<template>
	<edit-user-form form-type="moreInfo">
		<template #default="{ form, inputColor, canEdit, update }">
			<v-row dense>
				<v-col cols="12" sm="6">
					<date-field
						v-model="form.data.moveInDate"
						:color="inputColor"
						:readonly="!canEdit"
						label="Move-In Date"
						:max="new Date().toISOString().substr(0, 10)"
						min="1900-01-01"
						@input="update(['moveInDate', $event])"
					/>
				</v-col>
				<v-col cols="12" sm="6">
					<v-select
						v-model="form.data.residenceType"
						:color="inputColor"
						:readonly="!canEdit"
						:items="residenceTypes"
						:append-icon="canEdit ? 'fa-caret-down' : ''"
						label="Residence Type"
						:clearable="canEdit"
						@input="update(['residenceType', $event])"
					/>
				</v-col>
				<v-col cols="12">
					<v-select
						v-model="form.data.careSetting"
						:color="inputColor"
						:readonly="!canEdit"
						:items="careSettings"
						:append-icon="canEdit ? 'fa-caret-down' : ''"
						label="Care Setting"
						:clearable="canEdit"
						@input="update(['careSetting', $event])"
					/>
				</v-col>
			</v-row>
		</template>
	</edit-user-form>
</template>

<script>
import EditUserForm from "./EditUserForm";
import DateField from "@/components/shared/DateField";

const residenceTypes = [
	{ text: "Studio", value: "Studio" },
	{ text: "One-Bedroom", value: "One_Bedroom" },
	{ text: "Two-Bedroom", value: "Two_Bedroom" },
	{ text: "Companion Suite", value: "Companion_Suite" },
	{ text: "Single", value: "Single" },
	{ text: "Double", value: "Double" },
	{ text: "Shared", value: "Shared" },
	{ text: "Condo", value: "Condo" },
];

const careSettings = [
	{ text: "Standard", value: "Standard" },
	{ text: "Independent", value: "Independent" },
	{ text: "Assisted", value: "Assisted" },
	{ text: "Memory Care", value: "Memory_Care" },
	{ text: "Skilled Nursing", value: "Skilled_Nursing" },
];

export default {
	components: { EditUserForm, DateField },
	data: () => ({
		residenceTypes,
		careSettings,
	}),
};
</script>
